module.exports = __webpack_public_path__ + "static/mediaweb.3ba7845d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/mediaweb.png
// module id = 726
// module chunks = 213534597649335